import { deserialize, object, optional, serializable } from 'serializr';

export class LinearTeamModel {
  @serializable
  public id: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(LinearTeamModel, input));
  }
}

export class LinearTeamProjectModel {
  @serializable
  public id: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(LinearTeamProjectModel, input));
  }
}

export class LinearTeamIssueModel {
  @serializable
  public id: string;
  @serializable
  public title: string;
  @serializable
  public identifier: string;
  @serializable
  public description: string;
  @serializable(optional(object(LinearTeamProjectModel)))
  public project: LinearTeamProjectModel;
  @serializable(optional(object(LinearTeamProjectModel)))
  public team: LinearTeamProjectModel;
  @serializable
  public createdAt: string;
  @serializable
  public updatedAt: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(LinearTeamIssueModel, input));
  }
}
